// Import all your images
import laptopImg from '../../assets/service/laptopImagebest.png';
import printerImg from '../../assets/service/printerImg.png';
import cctvImg from '../../assets/service/cameraImg.png';
import networkingImg from '../../assets/service/netwokingImg.png';
import softwareImg from '../../assets/service/softwareimg.png';
import industrialpc from '../../assets/service/industrialpc.png';
import amcImg from '../../assets/service/amcImg.png';
import accessoriesImg from '../../assets/service/accesorriesImg.png';

const ServicesData = [
    {   
        slug: 'Laptop',
        imageUrl: laptopImg,
        title: 'Laptop',
        description: 'Explore a wide range of laptops for personal, professional, and business use, along with expert repair, upgrades, and accessories for seamless performance.',
    },
    {
        slug: 'CCTV',
        imageUrl: cctvImg,
        title: 'CCTV',
        description: 'Advanced CCTV surveillance solutions for homes, offices, and industries, providing reliable security, remote monitoring, and expert installation services.',
    },
    {
        slug: 'industrialpc',
        imageUrl: industrialpc,
        title: 'Industrial PC',
        description: 'High-performance, rugged Advantech Industrial PCs built for automation, factory control, and industrial environments requiring 24/7 reliability.',
    },
    {
        slug: 'networkingServices',
        imageUrl: networkingImg,
        title: 'Networking',
        description: 'Complete networking solutions including LAN/WAN, Wi-Fi, structured cabling, and secure connectivity for offices, industries, and smart setups.',
    },  
    {
        slug: 'amcservices',
        imageUrl: amcImg,
        title: 'AMC Services',
        description: 'Comprehensive Annual Maintenance Contracts (AMC) for IT systems, ensuring smooth operation, timely updates, and minimal downtime across all devices.',
    },
    {
        slug: 'printersservices',
        imageUrl: printerImg,
        title: 'Printers',
        description: 'Complete printing solutions with sales, repairs, cartridge refilling, and setup support for homes, offices, schools, and industrial environments.',
    },
    {
        slug: 'itaccessories',
        imageUrl: accessoriesImg,
        title: 'IT Accessories',
        description: 'A wide range of essential IT peripherals including keyboards, mice, headsets, webcams, cables, UPS, and power accessories for home, office, and industrial use.',
    },
    {
        slug: 'software',
        imageUrl: softwareImg,
        title: 'Software Services',
        description: 'Genuine software licensing, installation, and support for operating systems, productivity suites, CAD tools, antivirus, accounting software, and cloud applications.',
    }
];

export default ServicesData;
